import eventbus from '../eventBus'

export default {
    data() {
      return {
        loading: false,
        keywords: '',
        result : this.getEmptyResult(),
        removeModalVisible: false,
        removeModel: {
          hasError: false,
          errorMessage: ''
        },
        internalTableName: ''
      }
    },
    created() {
      this.fetchData(1)
    },
    methods: {
      getEmptyResult() {
        return {
            pageIndex: 1,
            pageCount: 0,
            rowCount: 0,
            pageSize: 0,
            data:[]
        }
      },
      search() {
          this.fetchData(1)
          return false
      },
      onPageIndexChanged(p, tableName) {
        this.fetchData(p)
        this.internalTableName = tableName
      },
      showLoading() {
        this.loading = true
        eventbus.$emit('ui-action:loading', true)
      },
      hideLoading() {
        this.loading = false
        eventbus.$emit('ui-action:loading', false)
      },
      resetRemoveModal() {
        this.removeModel.hasError = false
        this.removeModel.errorMessage = ''
      },
      showRemoveModal() {
        this.removeModel.hasError = false
        this.removeModel.errorMessage = ''
        this.removeModalVisible = true
      },
      handleRemoveModalOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        this.removeModel.hasError = false
        this.removeModel.errorMessage = ''
        // Trigger submit handler
        this.handleRemoveSubmit()
      }
    }
  }